import { render, staticRenderFns } from "./search_box.vue?vue&type=template&id=7c5824bd&scoped=true"
import script from "./search_box.vue?vue&type=script&lang=js"
export * from "./search_box.vue?vue&type=script&lang=js"
import style0 from "./search_box.vue?vue&type=style&index=0&id=7c5824bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5824bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c5824bd')) {
      api.createRecord('7c5824bd', component.options)
    } else {
      api.reload('7c5824bd', component.options)
    }
    module.hot.accept("./search_box.vue?vue&type=template&id=7c5824bd&scoped=true", function () {
      api.rerender('7c5824bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/search_box.vue"
export default component.exports